module.exports = __webpack_public_path__ + "static/media/memoriesLogo.dc8bbfe3.png";